module.exports = __webpack_public_path__ + "arrow-next.jpg?7aafbc9024bc8dd1a5a82f54dc30e9ec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-next.jpg
// module id = 154
// module chunks = 0